import gql from 'graphql-tag';

import fileFragment from '~/shared/graphql-queries/files/file-fragment';

export default gql`
  mutation createOneFileMutation($record: CreateOneFileInput!) {
    createOneFileMutation(record: $record) {
      recordId
      record {
        ...FileFragment
      }
      message
      title
    }
  }
  ${fileFragment}
`;
